import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { makeGridGetRowsResponse } from '@cbridge-tools/default-data-grid';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { toApiSort } from '@cbridge-utils/datagrid';
import { SymbolAction } from '../symbol.action';
import { SymbolTranslator } from '../symbol.translator';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.loadList.started),
  mergeMap((params) => {
    const { resolve, reject, sort, ...payload } = params;

    return dependencies.api.getSymbolList({
      ...payload,
      sort: toApiSort(sort),
    }).pipe(
      mergeMap((response) => {
        const { symbols, totalCount, filteredCount } = response;

        const items = symbols.map(SymbolTranslator.fromApi);
        resolve?.(makeGridGetRowsResponse(items, filteredCount));

        return [
          SymbolAction.loadList.done({ params, result: { items, totalCount, filteredCount } }),
        ];
      }),
      catchApiError((error) => {
        reject?.(error?.description);
        return [
          SymbolAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
